// extracted by mini-css-extract-plugin
export default {"tile":"base_tile__WIDS-","tileBody":"base_tileBody__IE5qy"};